(function (global) {
  "use strict";

  // aw_planner_localizations_20260810

  function clamp(value, min, max) {
    return Math.min(max, Math.max(min, value));
  }

  function calculate(candles, fillWeight, load) {
    var total = Math.max(0, candles) * Math.max(0, fillWeight);
    var wax = total / (1 + load / 100);
    return { total: total, wax: wax, oil: total - wax };
  }

  function formatGrams(value) {
    return Math.round(value).toLocaleString("en-GB") + " g";
  }

  function middleLoad(fragrance) {
    return clamp(8, fragrance.min, fragrance.max);
  }

  global.AWStarterBatchPlannerMath = {
    clamp: clamp,
    calculate: calculate,
    formatGrams: formatGrams,
  };

  if (typeof document === "undefined") return;

  function initPlanner(root) {
    if (root.dataset.awReady === "true") return;

    var i18nNode = root.querySelector("[data-aw-translations]");
    var i18nPayload = { locale: "en-GB", strings: {} };
    try {
      i18nPayload = JSON.parse(i18nNode ? i18nNode.textContent : "{}");
    } catch {
      i18nPayload = { locale: "en-GB", strings: {} };
    }
    var locale = i18nPayload.locale || document.documentElement.lang || "en-GB";
    var strings = i18nPayload.strings || {};
    var numberFormatter;
    try {
      numberFormatter = new Intl.NumberFormat(locale === "en" ? "en-GB" : locale);
    } catch {
      numberFormatter = new Intl.NumberFormat("en-GB");
    }

    function copy(key, variables) {
      var output = String(strings[key] || key);
      Object.keys(variables || {}).forEach(function (name) {
        output = output.split("{" + name + "}").join(String(variables[name]));
      });
      return output;
    }

    function formatLocalizedGrams(value) {
      return numberFormatter.format(Math.round(value)) + " g";
    }

    var dataNode = root.querySelector("[data-aw-fragrances]");
    var fragrances = [];

    function normalizeFragrance(item) {
      if (!item || !item.name) return null;
      var numbers = String(item.range || "").match(/[0-9]+(?:[.,][0-9]+)?/g) || [];
      if (numbers.length === 0) return null;
      var min = Number(numbers[0].replace(",", "."));
      var max = Number((numbers[1] || numbers[0]).replace(",", "."));
      if (!Number.isFinite(min) || !Number.isFinite(max) || min > max) return null;
      return Object.assign({}, item, { min: min, max: max });
    }

    try {
      fragrances = JSON.parse(dataNode ? dataNode.textContent : "[]")
        .map(normalizeFragrance)
        .filter(Boolean);
    } catch {
      fragrances = [];
    }

    var rowsNode = root.querySelector("[data-aw-rows]");
    if (!rowsNode || fragrances.length === 0) {
      if (rowsNode) {
        rowsNode.innerHTML = '<tr><td colspan="7" class="aw-batch-planner__empty">' + escapeHtml(copy("table.empty")) + '</td></tr>';
      }
      return;
    }

    root.dataset.awReady = "true";

    function normalizeCandleCount(value) {
      var number = Math.round(Number(value));
      if (!Number.isFinite(number)) return 0;
      return Math.min(Number.MAX_SAFE_INTEGER, Math.max(0, number));
    }

    var totalCandles = normalizeCandleCount(root.dataset.totalCandles || 25);
    var minWeight = Number(root.dataset.minWeight) || 20;
    var maxWeight = Number(root.dataset.maxWeight) || 500;
    var fillWeight = clamp(Number(root.dataset.defaultWeight) || 200, minWeight, maxWeight);
    var nextId = 2;
    var rows = [
      {
        id: 1,
        fragranceId: fragrances[0].id,
        candles: totalCandles,
        load: middleLoad(fragrances[0]),
      },
    ];

    var totalCandlesInput = root.querySelector("[data-aw-total-candles]");
    var totalCandlesMinus = root.querySelector("[data-aw-total-minus]");
    var totalCandlesPlus = root.querySelector("[data-aw-total-plus]");
    var tableCaption = root.querySelector("[data-aw-table-caption]");
    var weightInput = root.querySelector("[data-aw-weight]");
    var minusButton = root.querySelector("[data-aw-weight-minus]");
    var plusButton = root.querySelector("[data-aw-weight-plus]");
    var addButton = root.querySelector("[data-aw-add]");
    var allocationCount = root.querySelector("[data-aw-allocation-count]");
    var allocationBar = root.querySelector("[data-aw-allocation-bar]");
    var allocationMessage = root.querySelector("[data-aw-allocation-message]");
    var summaryTitle = root.querySelector("[data-aw-summary-title]");
    var totalWax = root.querySelector("[data-aw-total-wax]");
    var totalOil = root.querySelector("[data-aw-total-oil]");
    var totalBatch = root.querySelector("[data-aw-total-batch]");
    var exampleWax = root.querySelector("[data-aw-example-wax]");
    var exampleOil = root.querySelector("[data-aw-example-oil]");
    var exampleTotal = root.querySelector("[data-aw-example-total]");
    if (exampleWax) exampleWax.textContent = formatLocalizedGrams(4630);
    if (exampleOil) exampleOil.textContent = formatLocalizedGrams(370);
    if (exampleTotal) exampleTotal.textContent = formatLocalizedGrams(5000);

    function getFragrance(id) {
      return fragrances.find(function (item) { return item.id === id; }) || fragrances[0];
    }

    function updateWeightControls() {
      weightInput.value = String(fillWeight);
      minusButton.disabled = fillWeight <= minWeight;
      plusButton.disabled = fillWeight >= maxWeight;
    }

    function updateCandleCountControls() {
      totalCandlesInput.value = String(totalCandles);
      totalCandlesMinus.disabled = totalCandles <= 0;
    }

    function setTotalCandles(value) {
      var nextTotal = normalizeCandleCount(value);
      var allocated = rows.reduce(function (sum, row) { return sum + row.candles; }, 0);
      totalCandles = Math.max(nextTotal, allocated);
      render();
    }

    function updateDynamicCopy() {
      tableCaption.textContent = copy(
        totalCandles === 1 ? "table.caption_one" : "table.caption_other",
        { count: totalCandles }
      );
    }


    function updateRow(id, patch) {
      rows = rows.map(function (row) {
        if (row.id !== id) return row;
        return Object.assign({}, row, patch);
      });
      render();
    }

    function chooseFragrance(rowId, fragranceId) {
      var fragrance = getFragrance(fragranceId);
      var row = rows.find(function (item) { return item.id === rowId; });
      updateRow(rowId, {
        fragranceId: fragranceId,
        load: clamp(row.load, Number(fragrance.min), Number(fragrance.max)),
      });
    }

    function addFragrance() {
      if (totalCandles === 0 || rows.length >= totalCandles || rows.length >= fragrances.length) return;

      var used = new Set(rows.map(function (row) { return row.fragranceId; }));
      var nextFragrance = fragrances.find(function (item) { return !used.has(item.id); }) || fragrances[0];
      rows.push({
        id: nextId,
        fragranceId: nextFragrance.id,
        candles: 0,
        load: middleLoad(nextFragrance),
      });
      nextId += 1;
      render();
    }

    function removeFragrance(id) {
      if (rows.length === 1) return;
      rows = rows.filter(function (row) { return row.id !== id; });
      render();
    }

    function selectMarkup(selectedId) {
      return fragrances.map(function (item) {
        var selected = item.id === selectedId ? " selected" : "";
        return '<option value="' + escapeHtml(item.id) + '"' + selected + '>' + escapeHtml(item.name) + "</option>";
      }).join("");
    }

    function escapeHtml(value) {
      return String(value)
        .replace(/&/g, "&amp;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;")
        .replace(/"/g, "&quot;")
        .replace(/'/g, "&#039;");
    }

    function rowMarkup(row, index) {
      var fragrance = getFragrance(row.fragranceId);
      var result = calculate(row.candles, fillWeight, row.load);
      var min = Number(fragrance.min);
      var max = Number(fragrance.max);
      var sliderProgress = ((row.load - min) / (max - min || 1)) * 100;
      var allocatedElsewhere = rows.reduce(function (sum, item) {
        return sum + (item.id === row.id ? 0 : item.candles);
      }, 0);
      var maxCandles = Math.max(0, totalCandles - allocatedElsewhere);

      return [
        '<tr data-row-id="' + row.id + '">',
          '<td data-label="' + escapeHtml(copy("table.fragrance_oil")) + '">',
            '<label class="aw-batch-planner__fragrance-field">',
              '<span class="aw-batch-planner__batch-index">' + String(index + 1).padStart(2, "0") + '</span>',
              '<select data-action="fragrance" aria-label="' + escapeHtml(copy("table.fragrance_batch_aria", { index: index + 1 })) + '">',
                selectMarkup(row.fragranceId),
              '</select>',
            '</label>',
          '</td>',
          '<td data-label="' + escapeHtml(copy("table.candles")) + '">',
            '<input class="aw-batch-planner__compact-input" data-action="candles" type="number" min="0" max="' + maxCandles + '" step="1" value="' + row.candles + '" inputmode="numeric" aria-label="' + escapeHtml(copy("table.candles_batch_aria", { index: index + 1 })) + '">',
          '</td>',
          '<td class="aw-batch-planner__range" data-label="' + escapeHtml(copy("table.recommended_range")) + '">',
            '<strong>' + min + '–' + max + ((String(locale).toLowerCase().startsWith("de") || String(locale).toLowerCase() === "pt-pt") ? ' %' : '%') + '</strong>',
            '<small>' + escapeHtml(copy("table.of_wax_weight")) + '</small>',
          '</td>',
          '<td data-label="' + escapeHtml(copy("table.your_amount")) + '">',
            '<label class="aw-batch-planner__load">',
              '<span class="aw-batch-planner__load-value">',
                '<input data-action="load-number" type="number" min="' + min + '" max="' + max + '" step="0.5" value="' + row.load + '" inputmode="decimal" aria-label="' + escapeHtml(copy("table.percentage_batch_aria", { index: index + 1 })) + '">',
                '<span>' + ((String(locale).toLowerCase().startsWith("de") || String(locale).toLowerCase() === "pt-pt") ? ' %' : '%') + '</span>',
              '</span>',
              '<input class="aw-batch-planner__slider" data-action="load-slider" type="range" min="' + min + '" max="' + max + '" step="0.5" value="' + row.load + '" aria-label="' + escapeHtml(copy("table.slider_batch_aria", { index: index + 1 })) + '" style="--aw-slider-progress:' + sliderProgress + '%">',
            '</label>',
          '</td>',
          '<td class="aw-batch-planner__result" data-label="' + escapeHtml(copy("table.wax_needed")) + '"><strong>' + formatLocalizedGrams(result.wax) + '</strong></td>',
          '<td class="aw-batch-planner__result aw-batch-planner__oil-result" data-label="' + escapeHtml(copy("table.oil_needed")) + '"><strong>' + formatLocalizedGrams(result.oil) + '</strong></td>',
          '<td class="aw-batch-planner__remove-cell">',
            '<button class="aw-batch-planner__remove" data-action="remove" type="button"' + (rows.length === 1 ? " disabled" : "") + ' aria-label="' + escapeHtml(copy("table.remove_batch_aria", { index: index + 1 })) + '" title="' + escapeHtml(copy("table.remove_fragrance_title")) + '">×</button>',
          '</td>',
        '</tr>',
      ].join("");
    }

    function bindRowEvents() {
      rowsNode.querySelectorAll("tr[data-row-id]").forEach(function (rowNode) {
        var rowId = Number(rowNode.dataset.rowId);
        var fragranceSelect = rowNode.querySelector('[data-action="fragrance"]');
        var candlesInput = rowNode.querySelector('[data-action="candles"]');
        var loadNumber = rowNode.querySelector('[data-action="load-number"]');
        var loadSlider = rowNode.querySelector('[data-action="load-slider"]');
        var removeButton = rowNode.querySelector('[data-action="remove"]');

        fragranceSelect.addEventListener("change", function () {
          chooseFragrance(rowId, fragranceSelect.value);
        });

        candlesInput.addEventListener("change", function () {
          var allocatedElsewhere = rows.reduce(function (sum, item) {
            return sum + (item.id === rowId ? 0 : item.candles);
          }, 0);
          var remaining = Math.max(0, totalCandles - allocatedElsewhere);
          updateRow(rowId, {
            candles: clamp(Math.round(Number(candlesInput.value) || 0), 0, remaining),
          });
        });

        loadNumber.addEventListener("change", function () {
          var row = rows.find(function (item) { return item.id === rowId; });
          var fragrance = getFragrance(row.fragranceId);
          updateRow(rowId, {
            load: clamp(Number(loadNumber.value) || Number(fragrance.min), Number(fragrance.min), Number(fragrance.max)),
          });
        });

        loadSlider.addEventListener("change", function () {
          updateRow(rowId, { load: Number(loadSlider.value) });
        });

        removeButton.addEventListener("click", function () {
          removeFragrance(rowId);
        });
      });
    }

    function render() {
      var planned = rows.reduce(function (sum, row) { return sum + row.candles; }, 0);
      var complete = totalCandles > 0 && planned === totalCandles;
      var totals = rows.reduce(function (sum, row) {
        var result = calculate(row.candles, fillWeight, row.load);
        return {
          wax: sum.wax + result.wax,
          oil: sum.oil + result.oil,
          total: sum.total + result.total,
        };
      }, { wax: 0, oil: 0, total: 0 });

      rowsNode.innerHTML = rows.map(rowMarkup).join("");
      bindRowEvents();
      updateWeightControls();
      updateCandleCountControls();
      updateDynamicCopy();

      allocationCount.textContent = copy("allocation.count", { planned: planned, total: totalCandles });
      allocationCount.className = complete ? "is-complete" : "is-incomplete";
      allocationBar.style.width = totalCandles === 0 ? "0%" : Math.min(100, (planned / totalCandles) * 100) + "%";
      allocationMessage.textContent = totalCandles === 0
        ? copy("allocation.enter_total")
        : complete
          ? copy("allocation.complete")
          : copy("allocation.adjust", { total: totalCandles });
      allocationMessage.className = complete ? "is-complete" : "is-incomplete";

      summaryTitle.textContent = totalCandles === 0
        ? copy("summary.enter_total")
        : complete
          ? copy("summary.ready")
          : copy(planned === 1 ? "summary.current_one" : "summary.current_other", { count: planned });
      totalWax.textContent = formatLocalizedGrams(totals.wax);
      totalOil.textContent = formatLocalizedGrams(totals.oil);
      totalBatch.textContent = formatLocalizedGrams(totals.total);
      addButton.disabled = totalCandles === 0 || rows.length >= totalCandles || rows.length >= fragrances.length;
    }

    totalCandlesInput.addEventListener("change", function () {
      setTotalCandles(totalCandlesInput.value);
    });
    totalCandlesMinus.addEventListener("click", function () {
      setTotalCandles(totalCandles - 1);
    });
    totalCandlesPlus.addEventListener("click", function () {
      setTotalCandles(totalCandles + 1);
    });

    weightInput.addEventListener("change", function () {
      fillWeight = clamp(Number(weightInput.value) || minWeight, minWeight, maxWeight);
      render();
    });

    minusButton.addEventListener("click", function () {
      fillWeight = clamp(fillWeight - 5, minWeight, maxWeight);
      render();
    });

    plusButton.addEventListener("click", function () {
      fillWeight = clamp(fillWeight + 5, minWeight, maxWeight);
      render();
    });

    addButton.addEventListener("click", addFragrance);
    root.querySelector("[data-aw-print]").addEventListener("click", function () { global.print(); });

    render();
  }

  function initAll(scope) {
    var target = scope || document;
    if (target.matches && target.matches("[data-aw-batch-planner]")) initPlanner(target);
    target.querySelectorAll("[data-aw-batch-planner]").forEach(initPlanner);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () { initAll(document); });
  } else {
    initAll(document);
  }

  document.addEventListener("shopify:section:load", function (event) {
    initAll(event.target);
  });
})(typeof window !== "undefined" ? window : globalThis);
